import { NavLink, Outlet, useLocation } from "react-router-dom";

// src/components/Inventory.js
function Report() {
  const location = useLocation();
  const pathname = location.pathname;
  // Mark "Production Scheduling" as active if the current URL is "/production" or "/production/scheduling"
  const isSchedulingActive =
    pathname === "/reports" || pathname === "/reports/googlesheet";
  return (
    <div className="page-container">
      <aside>
        <ul>
          <li>
            <NavLink
              to="googlesheet"
              end
              className={({ isActive }) => (isSchedulingActive ? "active" : "")}
            >
              Google Sheet Util
            </NavLink>
          </li>
        </ul>
      </aside>
      <main>
        {/* Renders the selected left nav child component */}
        <Outlet />
      </main>
    </div>
  );
}

export default Report;
